import type { ApiClient } from "@/clients/ApiClient";
import { fromEither } from "./compat";

export interface AuthorsApi {
    /** The author with their podcasts. Throws when there is no such author. */
    bySlug(slug: string): Promise<Author>;
}

export const createAuthorsApi = (client: ApiClient): AuthorsApi => ({
    async bySlug(slug) {
        const author = fromEither<Author | null>(
            await client.get(`/authors/bySlug/${encodeURIComponent(slug)}`),
            "author"
        );
        if (!author) {
            throw new Error(`Author not found: ${slug}`);
        }
        // The Go API leaves out empty fields, the pages read them as strings and lists
        return {
            ...author,
            content: author.content ?? "",
            art: author.art ?? "",
            url: author.url ?? "",
            copyright: author.copyright ?? "",
            podcasts: author.podcasts ?? [],
        };
    },
});
